
// TYPES PAGE VIEW PRECIO
export const GET_LISTA ="GET_LISTA"
export const CHANGE_CATEGORIA ="CHANGE_CATEGORIA"
export const ERROR_LISTA ="ERROR_LISTA"


// RESPONSE API
export const SUCCESSFUL="SUCCESSFUL"
export const ERROR="ERROR"